<template>
  <div class="task-carousel fh">
    <!-- HEADER SECTION -->
    <div class="module-header">
      <h1 class="module-name">Workflow Dashboard</h1>
      <!-- <div class="right-controls">
        <input type="text" placeholder="Search..." class="search-input" />
        <button class="btn btn-black">+ New Task</button>
      </div> -->
    </div>

    <div class="filter-tabs mb-2">
      <div v-for="(tab, index) in tabs" :key="index" class="tab" :class="{ active: selectedTab === index }" @click="changeTab(tab)">
      <img v-if="index !== 0" width="12px" :src="tab.icon" alt=""/>
        {{ tab.name }} <span>{{ tab.count }}</span>
      </div>
    </div>

    <div class="fh fw center" v-if="loading">
      <loading-circle />
    </div>

    <!-- CAROUSEL TABLES -->
    <div v-else class="list">
      <div
        v-for="(group, index) in taskGroups"
        :key="index"
        class="task-group"
      >
        <div class="header" @click="toggle(index)">
          <div class="heading-name">{{ group.name }}</div>
          <span>{{ expanded[index] ? '−' : '+' }}</span>
        </div>

        <div v-if="expanded[index]" class="copy-dtx-table material-master-table--table">
          <table>
            <thead>
              <tr>
                <th>Workflow</th>
                <th>Step Name</th>
                <th>
                  <button type="button" class="sortable-header" @click="updateSort('category')">
                    <span>Category</span>
                    <span
                      v-if="sort.field !== 'category'"
                      class="sortable-indicator"
                      aria-hidden="true"
                    ></span>
                    <img
                      v-if="sort.field === 'category' && sort.direction === 'asc'"
                      src="~@/assets/images/icons/arrow-up-icon.svg"
                      alt="Ascending"
                    >
                    <img
                      v-else-if="sort.field === 'category' && sort.direction === 'desc'"
                      src="~@/assets/images/icons/arrow-down-icon.svg"
                      alt="Descending"
                    >
                  </button>
                </th>
                <th>
                  <button type="button" class="sortable-header" @click="updateSort('planned_start_date')">
                    <span>Planned Start Date</span>
                    <span
                      v-if="sort.field !== 'planned_start_date'"
                      class="sortable-indicator"
                      aria-hidden="true"
                    ></span>
                    <img
                      v-if="sort.field === 'planned_start_date' && sort.direction === 'asc'"
                      src="~@/assets/images/icons/arrow-up-icon.svg"
                      alt="Ascending"
                    >
                    <img
                      v-else-if="sort.field === 'planned_start_date' && sort.direction === 'desc'"
                      src="~@/assets/images/icons/arrow-down-icon.svg"
                      alt="Descending"
                    >
                  </button>
                </th>
                <th>Status</th>
                <th>Due On</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="group.tasks.length === 0">
                <td colspan="6" style="text-align: center;">No Data Found</td>
              </tr>
              <tr v-for="(task, i) in group.tasks" :key="i">
                <td class="elipsis-text" v-overflow-tooltip>{{ task.description }}</td>
                <td v-overflow-tooltip>{{ task.name }}</td>
                <td v-overflow-tooltip>{{ config.WORKFLOW_TYPES[task.category] || '--' }}</td>
                <td>{{ task.estimation | genericFormatDate }}</td>
                <td>
                  <span
                    :class="['status', getStatusClass(task.dueOn)]"
                  >
                    {{ getStatusLabel(task.dueOn) }}
                  </span>
                </td>
                <td>{{ task.dueOn | genericFormatDate }}</td>
                <td>
                  <img @click="goTo(task)" class="edit url pointer" v-tooltip="'URL'" src="~@/assets/images/url.svg" alt=""/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  <modal :open="workflowDetailsModalObject.open" @close="workflowDetailsModalObject.open = false" :closeOnOutsideClick="true" :title="'Workflow Details'">
    <div class="workflow-details">
      <workflow-instance-edit-panel
      v-if="workflowDetailsModalObject.open"
      ref="WorkflowDetailsPanel"
      :wfInstanceId="workflowDetailsModalObject.id"
      :feature="config.CORE_FEATURES.TENANT"
      :panel-style="'alternate'"
      @finishWorkflow="finishWorkflow"
      />
      </div>
  </modal>
  </div>
</template>

<script>
import loadingCircle from '@/components/common/loadingCircle.vue'
import { genericFormatDate } from '@/utils/date'
import { getWorkflowDashbordData, getTenantDefaults } from '@/api'
import { mapGetters } from 'vuex'
import Modal from '@/components/common/modal.vue'
import WorkflowInstanceEditPanel from '@/views/FORM/workflowInstanceEditPanel.vue'
import config from '@/config'
import { getTokenStorage, projectExchangeToken } from '@/api/session'

export default {
  name: 'WorkflowDashboard',
  components: {
    loadingCircle,
    Modal,
    WorkflowInstanceEditPanel
  },
  filters: {
    genericFormatDate
  },
  data () {
    return {
      config: config,
      workflowDetailsModalObject: {
        open: false,
        id: null
      },
      loading: false,
      taskGroups: [
        {
          name: 'Actionable Workflows',
          tasks: []
        },
        {
          name: 'Upcoming This Week',
          task: []
        }
      ],
      expanded: [true, false, false],
      tabs: [],
      selectedTab: 0,
      workflowType: 'all',
      sort: {
        field: 'planned_start_date',
        direction: 'asc'
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'isOnProjectLevel'])
  },
  mounted () {
    this.tabs = [
      { name: 'All Workflows', key: 'all', count: 0, icon: '' },
      { name: 'Forms', key: 'form', count: 0, icon: require('@/assets/images/exam.png') },
      { name: 'Materials', key: 'material', count: 0, icon: require('@/assets/images/product.png') },
      { name: 'Bom', key: 'bom', count: 0, icon: require('@/assets/images/structure.png') },
      { name: 'Documents', key: 'document', count: 0, icon: require('@/assets/images/file-text.png') },
      { name: 'Vendor', key: 'vendor', count: 0, icon: require('@/assets/images/icons/vendor-icon.svg') }
    ]
    if (this.user.tenantLevelRole !== 'ADMIN' || !this.isOnProjectLevel) {
      this.tabs.pop()
    }
    if (this.$route.query.tab) {
      const tabIndex = this.tabs.findIndex(tab => tab.key === this.$route.query.tab)
      if (tabIndex !== -1) {
        this.selectedTab = tabIndex
        this.workflowType = this.$route.query.tab
      }
    }
    this.fetchDashboardData()
    // this.upcomingDashboardData()
  },
  methods: {
    goTo (task) {
      if (task.category === config.WORKFLOW_TYPES_INVERTED.LIFECYCLE ||
       task.category === config.WORKFLOW_TYPES_INVERTED.ALTERNATE_MATERIAL) {
        this.workflowDetailsModalObject.id = task.workflowInstanceId
        this.workflowDetailsModalObject.open = true
      } else {
        const storage = getTokenStorage()
        const prevProjectId = storage.getItem('projectId')
        const newProjectId = task.project_id
        if (task.project_id) {
          const storage = getTokenStorage()
          storage.setItem('projectId', newProjectId, 'prevProjectId', prevProjectId)
          projectExchangeToken(() => {
          // Check if project has changed
            if (parseInt(prevProjectId) !== parseInt(newProjectId)) {
            // Project changed - need to call setup
              this.$store.dispatch('setup', () => {
                this.$router.push(task.link)
              })
            } else {
            // Same project - just get current project
              this.$store.dispatch('getCurrentProject', () => {
                this.$router.push(task.link)
              })
            }
          }, task.project_id)
        } else {
        // No project_id - remove project token and navigate
          const storage = getTokenStorage()
          storage.removeItem('dtxProjectToken')
          storage.removeItem('projectId')

          // If we had a project before, need to call setup to reset state
          if (prevProjectId) {
            this.$store.dispatch('setup', () => {
              this.$router.push(task.link)
            })
          } else {
            this.$router.push(task.link)
          }
        }
      }
    },
    toggle (index) {
      this.$set(this.expanded, index, !this.expanded[index])
    },
    updateSort (field) {
      if (this.sort.field === field) {
        this.sort.direction = this.sort.direction === 'asc' ? 'desc' : 'asc'
      } else {
        this.sort.field = field
        this.sort.direction = 'asc'
      }
      this.fetchDashboardData()
    },
    fetchDashboardData () {
      this.loading = true
      const skipFetchingMaterialVendors = this.user.tenantLevelRole !== 'ADMIN' || this.isOnProjectLevel || this.workflowType !== 'all'
      getTenantDefaults().then(defaults => {
        const alternateMaterialWorkflowId = defaults.tenant_defaults[0]?.tenant_feature_configuration.MATERIAL?.ALTERNATE_MATERIAL_WORKFLOW_TEMPLATE_DEFAULT
        getWorkflowDashbordData(this.user?.userId, 'actionable', this.isOnProjectLevel, this.workflowType, alternateMaterialWorkflowId, skipFetchingMaterialVendors, this.sort)
          .then(res => {
            const apiData = res?.user_steps_view || []
            // if (!skipFetchingMaterialVendors) {
            //   apiData.push(...res?.materialVendors || [])
            // }
            const upcomingApiData = res?.upcoming || []
            // if (!skipFetchingMaterialVendors) {
            //   upcomingApiData.push(...res?.materialVendorsUpcoming || [])
            // }
            const upcomingTasks = upcomingApiData.map(item => {
              const obj = {
                name: item?.step_name || '',
                description: item?.workflow_name || '',
                estimation: item?.planned_start_date || '',
                category: item?.category || '',
                type: '',
                dueOn: this.getTaskDueDate(item),
                assignees: '',
                isMaterial: item.material_id || false,
                project_id: item?.core_form?.project_id,
                workflowInstanceId: item.workflow_instance_id
              }
              if (item.form_id) {
                obj.link = `/forms/template/${item?.core_form?.template_version?.core_form_template?.id}/form/${item?.core_form?.id}/view`
              } else if (item.approval_tenant_id) {
                obj.link = `/edit-user/${item?.approval_tenant_id}`
              }
              return obj
            })
            const mappedTasks = apiData.map(item => {
              const obj = {
                name: item?.step_name || '',
                description: item?.workflow_name || '',
                estimation: item?.planned_start_date || '',
                category: item?.category || '',
                type: '',
                dueOn: this.getTaskDueDate(item),
                assignees: '',
                isMaterial: item.material_id || false,
                project_id: item?.core_form?.project_id,
                workflowInstanceId: item.workflow_instance_id
              }
              if (item.form_id) {
                obj.link = `/forms/template/${item?.core_form?.template_version?.core_form_template?.id}/form/${item?.core_form?.id}/view`
              } else if (item.approval_tenant_id) {
                obj.link = `/edit-user/${item?.approval_tenant_id}`
              }
              return obj
            })
            for (const tab of this.tabs) {
              switch (tab.name) {
              case 'Forms':
                tab.count = res.form_workflows.aggregate.count
                break
              case 'Materials':
                tab.count = res.material_workflows.aggregate.count
                break
              case 'Vendor':
                tab.count = res.tenant_workflows.aggregate.count
                break
              case 'Documents':
                tab.count = res.document_workflows.aggregate.count
                break
              case 'Bom':
                tab.count = res.bom_workflows.aggregate.count
                break
              case 'All Workflows':
                tab.count =
                res.material_workflows.aggregate.count + res.form_workflows.aggregate.count +
                 res.document_workflows.aggregate.count + res.tenant_workflows.aggregate.count +
                 res.bom_workflows.aggregate.count
                break
              }
            }
            this.taskGroups[0].tasks = mappedTasks
            this.taskGroups[1].tasks = upcomingTasks
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
      }).catch(() => {
        this.loading = false
      })
    },
    changeTab (tab) {
      this.selectedTab = this.tabs.indexOf(tab)
      this.workflowType = tab.key
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: tab.key
        }
      })
      this.fetchDashboardData()
    },
    upcomingDashboardData () {
      this.loading = true
      getWorkflowDashbordData(this.user?.userId, 'upcoming', this.isOnProjectLevel, this.workflowType).then(res => {
        const apiData = res?.user_steps_view || []

        const mappedTasks = apiData.map(item => ({
          name: item?.step_name || '',
          description: item?.workflow_name || '',
          estimation: item?.planned_start_date || '',
          type: '',
          dueOn: this.getTaskDueDate(item),
          assignees: '',
          project_id: item?.core_form?.project_id,
          link: `/forms/template/${item?.core_form?.template_version?.core_form_template?.id}/form/${item?.core_form?.id}/view`
        }))

        this.taskGroups[1].tasks = mappedTasks
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getStatusLabel (dueDate) {
      return new Date(dueDate) < new Date() ? 'Overdue' : 'Open'
    },
    getStatusClass (dueDate) {
      return new Date(dueDate) < new Date() ? 'status-inactive' : 'status-active'
    },
    getTaskDueDate (item) {
      // Form due date updates are reflected in core_form.due_date.
      if (item?.form_id && item?.core_form?.due_date) {
        return item.core_form.due_date
      }
      return item?.due_date || ''
    },
    finishWorkflow () {
      this.$refs.WorkflowDetailsPanel.updateWorkflowMaterial(true)
    }
  }
}
</script>

<style lang="scss" scoped>
/* HEADER SECTION */

.workflow-details {
  min-width: 50rem;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  & .heading-name{
    font-size: var(--text-xl);
    font-weight: 500;
  }
}

.right-controls {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.search-input {
  padding: 0.4rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: var(--text-base);
}

/* TASK CAROUSEL STYLES */
.task-group {
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
}

.header {
  background-color: rgba(255, 240, 217, 0.6);
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  & .heading-name{
    font-size: var(--text-l);
    font-weight: 400;
  }
}

.table-wrapper {
  overflow-x: auto;
}

.sortable-header {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.sortable-header img {
  width: 12px;
  height: 12px;
}

.sortable-indicator {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 12px;
  opacity: 0.45;
}

.sortable-indicator::before,
.sortable-indicator::after {
  content: '';
  position: absolute;
  left: 1px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.sortable-indicator::before {
  top: 0;
  border-bottom: 4px solid currentColor;
}

.sortable-indicator::after {
  bottom: 0;
  border-top: 4px solid currentColor;
}

/* STATUS STYLES */
.status {
  font-size: var(--text-xs1);
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  font-weight: 400;
      padding: 4px 8px;
    border-radius: 6px;
    display: inline-block;
    text-align: center;
}
// .url {
//   width: 20px;
//   height: 20px;
// }

.status-active {
  background-color: #d4edda; /* light green */
  color: #155724;
}

.status-inactive {
    background-color: rgba(198, 39, 52, 0.1);
    color: rgb(255, 39, 39);
}

/* LINK CELL STYLING */
.link-blue {
  color: #1976d2;
  cursor: pointer;
}
.link-blue:hover {
  text-decoration: underline;
}

.filter-tabs {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 4px;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  background: #fff;
  width: max-content;
}

.tab {
  display: flex;
  align-items: center;
  gap: 6px; /* space between icon and text */
  padding: 6px 9px;
  font-size: var(--text-s);
  color: var(--);
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.tab img {
  width: 16px;
  height: 16px;
}

.tab span {
  background: #f3f5f7;
  padding: 0px 6px;
  border-radius: 6px;
  font-size: var(--text-s);
  color: #333;
}

/* Active tab styling */
.tab.active {
  background: #d9a06d;
  color: #fff;
}

.tab.active span {
  background: #ffffff44;
  color: #fff;
}
.material-master-table {
    height: calc(100% - 60px);
    &--table {
        max-height: calc(100vh - 250px);
    }
}
.list {
  padding-bottom: 1px;
}
</style>
